function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandIconClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Payroll_Concept",
    "data-name": "Payroll Concept"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.69,21.13H4.32a1.45,1.45,0,0,1-1.44-1.44V4.32A1.45,1.45,0,0,1,4.32,2.88H19.69a1.45,1.45,0,0,1,1.44,1.44V19.69A1.45,1.45,0,0,1,19.69,21.13ZM4.32,3.88a.44.44,0,0,0-.44.44V19.69a.44.44,0,0,0,.44.44H19.69a.44.44,0,0,0,.44-.44V4.32a.44.44,0,0,0-.44-.44Z",
    style: {
      fill: "#caccd0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.18,11.43v1.15h-2.6v2.6H11.43v-2.6H8.83V11.43h2.6V8.83h1.15v2.6Z",
    style: {
      fill: "#caccd0"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIconClosed);
export default __webpack_public_path__ + "static/media/expand_icon_closed.5e2605c9ca16613aa4425cb0967bc92c.svg";
export { ForwardRef as ReactComponent };